// extracted by mini-css-extract-plugin
module.exports = {"createButton":"AddUserModal_createButton__zZc8_","delete":"AddUserModal_delete__6MTld","note":"AddUserModal_note__1j-F3"};